import { UiTabPanelModel } from "../../models";

import { mockUiTabModel, mockUiTabModelContent } from "./mock-ui-tab";

import {
    mock$AssetModel,
    mockUiColumnModel,
    mockUiColumnModelContent,
    mockUiImageModel,
    mockUiImageModelContent,
    mockUiMarkdownModel,
    mockUiMarkdownModelContent
} from ".";

export function mockUiTabPanelModel({
    id = "tab-panel-1234",
    type = "uiTabPanel",
    locale = "en",
    content = mockUiTabPanelModelContent()
}: Partial<UiTabPanelModel> = {}): UiTabPanelModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiTabPanelModelContent = UiTabPanelModel["content"];

export function mockUiTabPanelModelContent({
    entryTitle = "Example Tab Panel Component",
    tabs = [
        mockUiTabModel({
            content: mockUiTabModelContent({
                buttonText: "Cards",
                columns: [
                    mockUiColumnModel({
                        id: "1",
                        content: mockUiColumnModelContent({
                            properties: {
                                xs: { align: "left", order: 2 },
                                md: { span: 5, order: 1 }
                            },
                            blocks: [
                                mockUiMarkdownModel({
                                    content: mockUiMarkdownModelContent({
                                        content: `## Manage tasks with ease \n\n ✓ &nbsp; **Members:** Keep everyone accountable and never have to ask “who’s doing that” by adding members to cards for their projects and tasks. \n\n ✓ &nbsp; **Due dates:** They're easy to set, hard to miss (with reminders!), and oh-so-satisfying to mark as “done.” \n\n ✓ &nbsp; **Attachments:** No more digging through endless email chains to find attachments. Just drag and drop them onto a card so the right files stay with the right tasks. \n\n ✓ &nbsp; **Checklists:** Your best tool to overpower overwhelming asks. Break big tasks into small ones, check things off the list, and watch that status bar go to 100% complete.`
                                    })
                                })
                            ]
                        })
                    }),
                    mockUiColumnModel({
                        id: "2",
                        content: mockUiColumnModelContent({
                            properties: {
                                xs: { align: "left", order: 1 },
                                md: { span: 6, offset: 1, order: 2 }
                            },
                            blocks: [
                                mockUiImageModel({
                                    content: mockUiImageModelContent({
                                        image: mock$AssetModel({
                                            url: "/ui-tab-panel/cards.png"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        }),
        mockUiTabModel({
            content: mockUiTabModelContent({
                buttonText: "Views",
                title: "Bring powerful new views to your team’s work.",
                columns: [
                    mockUiColumnModel({
                        id: "3",
                        content: mockUiColumnModelContent({
                            properties: {
                                xs: { align: "left", order: 2 },
                                md: { span: 5, order: 1 }
                            },
                            blocks: [
                                mockUiMarkdownModel({
                                    content: mockUiMarkdownModelContent({
                                        content: `✓ &nbsp; **Success starts with a Trello board:** Similar to a Kanban board, a Trello board is the easiest way to go from idea to action. Plan projects and break down each step of the way to getting things done. \n\n ✓ &nbsp; **Hit deadlines every time with Timeline:** Stay on top of every sprint and stay on track of every goal. Use Timeline to see how all of the moving parts piece together over time and drag and drop dates to make adjustments on the fly. \n\n ✓ &nbsp; **Use Calendar to stay on top of tasks:** Whether scheduling a quarterly editorial calendar or staying on top of your to-dos, Calendar is like a crystal ball giving you a clear vision of what work lies ahead.`
                                    })
                                })
                            ]
                        })
                    }),
                    mockUiColumnModel({
                        id: "4",
                        content: mockUiColumnModelContent({
                            properties: {
                                xs: { align: "left", order: 1 },
                                md: { span: 6, offset: 1, order: 2 }
                            },
                            blocks: [
                                mockUiImageModel({
                                    content: mockUiImageModelContent({
                                        image: mock$AssetModel({
                                            url: "/ui-tab-panel/views.png"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        }),
        mockUiTabModel({
            content: mockUiTabModelContent({
                buttonText: "Automation",
                title: "Create rules, buttons, and commands in Trello.",
                columns: [
                    mockUiColumnModel({
                        id: "5",
                        content: mockUiColumnModelContent({
                            properties: {
                                xs: { align: "left", order: 2 },
                                md: { span: 5, order: 1 }
                            },
                            blocks: [
                                mockUiMarkdownModel({
                                    content: mockUiMarkdownModelContent({
                                        content: `✓ &nbsp; **Rules for boards:** Setting rules means important tasks won’t fall through the cracks. Set a trigger and the actions to be performed, and let Butler run the show. \n\n ✓ &nbsp; **Move work forward:** Get to the next step faster with custom card and board buttons. Perform a series of actions in a single click! \n\n ✓ &nbsp; **Integrate your favorite apps:** Extend beyond your boards with integrations. Post messages to Slack, create Jira tickets, and send emails right from your boards. \n\n ✓ &nbsp; **Intelligent automation tips:** As you use a Trello board, Butler will recognize repetitive actions and suggest automations that can be enabled in a single click.`
                                    })
                                })
                            ]
                        })
                    }),
                    mockUiColumnModel({
                        id: "6",
                        content: mockUiColumnModelContent({
                            properties: {
                                xs: { align: "left", order: 1 },
                                md: { span: 6, offset: 1, order: 2 }
                            },
                            blocks: [
                                mockUiImageModel({
                                    content: mockUiImageModelContent({
                                        image: mock$AssetModel({
                                            url: "/ui-tab-panel/automation.png"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    ]
}: Partial<UiTabPanelModelContent> = {}): UiTabPanelModelContent {
    return {
        entryTitle,
        tabs
    };
}
